import React, { Component } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import EquipAnalysis from '../components/EquipAnalysis';
import PredictionAnalytics from '../components/PredictionAnalytics';
import Viewer from '../forge/Viewer';
import Projects from '../Data/sampleprojectdata.json';

const projectDetails = Projects.find(project => project.name === localStorage.getItem('projectName'))


class AnalyticsView extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  handleChange = name => event => {
    //if (name == "question1") 
    //event.target.value
  }

  render() {
    return (
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Grid container spacing={3}>

          {/* Chart */}
          <Grid item xs={12} md={6} lg={6}>

            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 500,
              }}
            >
              <Viewer
                // key={Math.random()}
                viewerDiv={'forgeViewer'}
                urn={projectDetails.modelUrn}
                showSensors={true}
                extensions={['IssuesExtension', 'HeatmapExtension', 'Autodesk.Viewing.MarkupsGui']}
                hasDwg={1}
              />
            </Paper>
            <br/>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
              <EquipAnalysis />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 1275,
              }}
            >
              <PredictionAnalytics />
            </Paper>
          </Grid>
          
        </Grid>

      </Container>
    )
  }
}

export default AnalyticsView;